export default __webpack_public_path__ + "static/media/icons8-artificial-intelligence-100.fa7c15a4.svg";